import { patientActions, userActions } from '_actions'
import { createReducer } from '@reduxjs/toolkit'
import { log } from '_services'

const initialState = {
};

export const reducer = createReducer(initialState, {
    [patientActions.loadRequest]: (state, action) => {
        var patient = {};

        if (action.payload) {
            patient[action.payload] = {
                id: action.payload,
                loading: true
            };
        }
        state = { ...state, ...patient };

        return state;
    },
    [patientActions.loadSuccess]: (state, action) => {
        var patients = {};

        Object.values(action.payload.entities.patients).forEach(x => {
            patients[x.id] = { ...action.payload.entities.patients[x.id], loading: false };
        });
        state = { ...state, ...patients };

        return state;
    },
    [userActions.loadSessionSuccess]: (state, action) => {
        if (action.payload.patientsContainer.entities) {
            return { ...state, ...action.payload.patientsContainer.entities.patients };
        } else {
            return state;
        }
    },
    [patientActions.loadFailure]: (state, action) => {
        log.error('Error loading patient.  ptno: ' + action.payload.ptno + ' error: ' + action.payload.error);
    },
    [patientActions.closeSuccess]: (state, action) => {
        delete state[action.payload];
    },
    [patientActions.updatePatientNotesSuccess]: (state, action) => {
        state[action.payload.ptno].notes = action.payload.notes;
    },
    [patientActions.updatePatientNotesFailure]: (state, action) => {
        log.error('Error updating patient notes.  ptno: ' + action.payload.ptno + ' error: ' + action.payload.error);
    },

})


